import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { FormatService } from 'src/core/services/format.service';
import { ContextService } from 'src/core/services/context.service';
import { QuoteItineraryGroupListView } from './quote-group-list.view';
import { QuoteItineraryGroupListDataService } from './quote-group-list.data';

interface Props extends ControllerProps<{}> {
}

@observer
export class QuoteItineraryGroupListController extends React.Component<Props, {}> {
	@resolve
	contextService: ContextService;

	@resolve
	formatService: FormatService;

	@resolve
	toast: ToastNotifications;

	@observable
	dataService: QuoteItineraryGroupListDataService;

	public componentDidMount(): void {
		this.initialize();
	}

	public render(): React.ReactNode {
		if (this.dataService == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<div className="panel">
					<QuoteItineraryGroupListView
						model={this.dataService}
						setBusy={this.props.setBusy}
						onItemDoubleClicked={this.handleItemDoubleClick}
					/>
				</div>
			</div>
		);
	}

	private async initialize(): Promise<void> {
		const { setBusy } = this.props;

		this.dataService = QuoteItineraryGroupListDataService.make(this.contextService, this.formatService);
		setBusy(true);
		this.dataService.addSorting('id', 'desc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);

		try {
			await this.dataService.load(query => query);
		} catch (error) {
			this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
		} finally {
			setBusy(false);
		}
	}

	private handleItemDoubleClick = (item: QuoteItineraryGroupSummary): void => {
		this.props.history.push(`/bookings/groups/${item == null ? 'new' : item.id}`);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/list/quote-group-list.controller.tsx